<div class="container-xl mt-3 mt-md-5">
  <div class="row mb-4 d-flex">
    <div class="col">
      <h3>{{ page_title }} {{ location_string }} ({{ salons.length }})</h3>
    </div>
  </div>
  <div class="row">
    <ng-container *ngFor="let salon of salons">
      <!-- <ng-container *ngIf="show_services === false || (show_services === true && (salon.categories.length > 0 || salon.servies.length > 0))"> -->
      <ng-container *ngIf="show_services === false || (show_services === true && (salon?.categories.length > 0 || salon?.servies.length > 0))">
        <div class="col-12 mb-4">
          <div class="row align-items-center">
            <div [class.col-6]="show_services === false" [class.col-12]="show_services === true" class="col-md-3 align-self-start">
              <div class="salon-logo-container">
                <img [src]="salon.banner_url" [alt]="salon.name">
                <h4>{{ salon.name }}</h4>
              </div>
            </div>
            <div [class.col-6]="show_services === false" [class.col-12]="show_services === true" class="col-md-9">
              <div class="row">
                <div class="col-12">
                  <table class="table salon-details">
                    <tr>
                      <th class="border-top-0 d-flex align-items-center justify-content-between">
                        {{ salon.name }} 
                        <a [routerLink]="'/salon/' + salon.slug" class="btn btn-outline-dark btn-sm float-right book-button">
                          View Salon
                        </a>
                    </th>
                    </tr>
                    <tr>
                      <td>{{ salon.address | replace:'\\n':', ':true }}</td>
                    </tr>
                    <tr *ngIf="salon.rating_count > 0">
                      <td class="border-top-0 mt-n2 pt-0">
                        <i class="fas fa-star"></i> {{ salon.average_rating }} ({{ salon.rating_count }})
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- <div class="col-12 col-md-4 d-flex align-items-center justify-content-center mr-auto mr-md-0">
                  <div>
                    
                  </div>
                </div> -->
              </div>
              <ng-container *ngIf="show_services === true">
                <div class="row">
                  <div class="col">
                    <table class="table table-sm">
                      <tbody>
                        <ng-container *ngFor="let category of salon.categories">
                          <ng-container *ngIf="category.services.length > 0">
                            <tr>
                              <th class="border-top border-bottom">{{ category.name }}</th>
                            </tr>
                            <tr *ngFor="let service of category.services">
                              <td class="border-top-0">
                                <div class="row align-items-center">
                                  <div class="col-12 col-md-8">
                                    {{ service.name }}
                                  </div>
                                  <div class="col-8 col-md-2">
                                    <div class="row">
                                      <div class="col-5 col-md-12">{{ service.price | currency}}</div>
                                      <div class="col-7 col-md-12"><small>{{ service.time_taken }}</small></div>
                                    </div>
                                  </div>
                                  <div class="col-4 col-md-2">
                                    <a [routerLink]="'/book-appointment/' + service.id" class="btn btn-outline-dark btn-sm book-button">
                                      <span (click)="setActiveSalon(salon, $event)">Book Now</span>
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="salons.length === 0">
      <div class="col-12 mb-4">
        <h5 class="montserrat-regular">{{ no_results }}</h5>
      </div>
    </ng-container>
  </div>
</div>